<template lang="pug">
    article#bolsasEdescontos
        Banner(nomePagina="Bolsas e Descontos")
        Apoio
        Condicoes
        Candidatar
        //- Pontualidade
        Prouni
        Duvidas
        BoaBolsa

</template>

<script>
import pagina from '@/mixins/pagina'
import Banner from '@components/BannerTemplates/BannerTemplates.vue'
import Apoio from '@sections/BolsasEdescontos/Apoio/Apoio.vue'
import Condicoes from '@sections/BolsasEdescontos/Condicoes/Condicoes.vue'
import Candidatar from '@sections/BolsasEdescontos/Candidatar/Candidatar.vue'
import Pontualidade from '@sections/BolsasEdescontos/Pontualidade/Pontualidade.vue'
import Prouni from '@sections/BolsasEdescontos/Prouni/Prouni.vue'
import BoaBolsa from '@sections/BolsasEdescontos/BoaBolsa/BoaBolsa.vue'
import Duvidas from '@sections/BolsasEdescontos/Duvidas/Duvidas.vue'

export default {
    name: "view-bolsas-edescontos",
    mixins: [
        pagina
    ],
    components: {
        Banner,
        Apoio,
        Condicoes,
        Candidatar,
        Pontualidade,
        Prouni,
        BoaBolsa,
        Duvidas
    },
}
</script>

<style lang="stylus" scoped src="./BolsasEdescontos.styl"></style>